declare global {
  interface Window {
    __configuration__: any;
  }
}

export enum Environments {
  DEV = 'development',
  TEST = 'test',
  PROD = 'production'
}

type PunchoutUIConfiguration = {
  apiUrl: string;
  environment: Environments;
  itemsPerPage: number;
  maxContentWidth?: number;
  maxBodyWidth?: number;
  // Entra ID (Azure AD) configuration
  azureTenantId: string;
  azureClientId: string;
  azureAuthority: string;
  authRedirectUri: string;
  /** Scope for the punchout-customer-bff Entra resource (aud). Access token audience. */
  apiScope: string;
  /** Base login scopes requested on sign-in (OIDC + Graph User.Read). */
  scopes: string[];
  /**
   * App roles / security groups required to access the portal. When empty (not yet
   * provisioned in Entra) access is granted to any authenticated user.
   */
  requiredRoles: string[];
  useLegacyAddCustomer: boolean;
};

const { __configuration__: CF } = window;

const splitList = (value?: string): string[] =>
  value ? value.split(/[\s,]+/).filter(Boolean) : [];

export const configuration: PunchoutUIConfiguration = {
  apiUrl: CF?.REACT_APP_API_URL ?? '',
  environment: CF?.REACT_APP_ENV,
  itemsPerPage: CF?.ITEMS_PER_PAGE ?? 10,
  maxContentWidth:
    parseInt(CF?.REACT_APP_AXIOS_MAX_CONTENT_LENGTH) || undefined,
  maxBodyWidth: parseInt(CF?.REACT_APP_AXIOS_MAX_BODY_LENGTH) || undefined,
  azureTenantId: CF?.REACT_APP_AZURE_TENANT_ID ?? '',
  azureClientId: CF?.REACT_APP_AZURE_CLIENT_ID ?? '',
  azureAuthority:
    CF?.REACT_APP_AZURE_AUTHORITY ||
    `https://login.microsoftonline.com/${CF?.REACT_APP_AZURE_TENANT_ID ?? ''}`,
  authRedirectUri: CF?.REACT_APP_AUTH_REDIRECT_URI || '/login/callback',
  apiScope: CF?.REACT_APP_API_SCOPE ?? '',
  scopes: splitList(CF?.REACT_APP_AZURE_SCOPES) || [
    'openid',
    'profile',
    'email',
    'User.Read'
  ],
  requiredRoles: splitList(CF?.REACT_APP_AZURE_REQUIRED_ROLES),
  useLegacyAddCustomer: CF?.REACT_APP_USE_LEGACY_ADD_CUSTOMER
    ? CF?.REACT_APP_USE_LEGACY_ADD_CUSTOMER === 'true'
    : true
};

// Fall back to the standard OIDC + Graph scopes when none are configured.
if (configuration.scopes.length === 0) {
  configuration.scopes = ['openid', 'profile', 'email', 'User.Read'];
}
